import {Route, Switch} from 'react-router-dom';
import {closeConnectModal, selectWallet} from '../../redux/wallet.slice';
import ConnectModal from '../components/connect-modal/connect-modal';
import Modal from '../components/modal/modal';
import {useAppDispatch, useAppSelector} from '../hooks';
import DisplayingFormPage from './displayng-form-by-type.page';
import HomePage from './home.page';
import InvestPage from './invest.page';

interface IProps {}

const Pages: React.FC<IProps> = () => {
  const dispatch = useAppDispatch();
  const {isConnectModalOpen} = useAppSelector(selectWallet);
  return (
    <>
      <Switch>
        <Route path="/:projectId/embed" exact>
          <DisplayingFormPage />
        </Route>
        <Route path="/:projectId" exact>
          <InvestPage />
        </Route>
        <Route path="/">
          <HomePage />
        </Route>
      </Switch>

      <Modal size="small" isOpen={isConnectModalOpen} onRequestClose={() => dispatch(closeConnectModal())}>
        <ConnectModal />
      </Modal>
    </>
  );
};

export default Pages;
